export default __webpack_public_path__ + "static/getTraction-ec455d24555169ab694ac893275dfe46.png";